import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

interface agoraConfig {

  apiBaseUrl: string,
  endpoints: {
    dashboard: string,
    attachment: string,
    minutes: string,
    agenda: string,
    task: string,
    attendee: string,
    meeting: string,
    recurMeeting: string,
    note: string,
    decision: string,
    user: string,
    login: string,
    collaboration: string,
    codelist: string,
    codelistOrg: string,
    search: string,
    solrSearch: string,
    template: string,
    tuleap: string,
    zoom: string,
    zoomURL: string,
    report: string,
    pheme: string,
    audio: string,
    webSocketEndPoint: string,
    teamsMeeting:string,
    teamsDiscussion:string,
    zoomAuthorizeEndpointURL: string,
    contextPath: string,
    getAllProteanForm: string,
    getFormDetails: string,
    saveFormResponse: string;
    getFormResposeDetails: string;
    advanceSearchUrl: string;
    collaboraURL: string;
    agendaSummary: string;
    meetingsFromAuth: string;
  }
}
declare var setAgoraConfig: any
@Injectable({
  providedIn: 'root'
})
export class AgoraConfigService {


  constructor(private http: HttpClient) { }
  AgoraConfig: BehaviorSubject<any> = new BehaviorSubject<any>([]);


  setEnvironmentConfig() {

    return new Promise((resolve, reject) => {

      const headers = new HttpHeaders({
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      });

      this.http.get("assets/config.json", { headers }).subscribe({
        next: (config: any) => {
          const conf_environment: agoraConfig = {

            apiBaseUrl: config.apiBaseUrl,
            endpoints: {
              dashboard: config.endpoints.dashboard,
              attachment: config.endpoints.attachment,
              minutes: config.endpoints.minutes,
              agenda: config.endpoints.agenda,
              agendaSummary: config.endpoints.agendaSummary,
              task: config.endpoints.task,
              attendee: config.endpoints.attendee,
              meeting: config.endpoints.meeting,
              recurMeeting: config.endpoints.recurMeeting,
              note: config.endpoints.note,
              decision: config.endpoints.decision,
              user: config.endpoints.user,
              login: config.endpoints.login,
              collaboration: config.endpoints.collaboration,
              codelist: config.endpoints.codelist,
              codelistOrg: config.endpoints.codelistOrg,
              search: config.endpoints.search,
              solrSearch: config.endpoints.solrSearch,
              template: config.endpoints.template,
              tuleap: config.endpoints.tuleap,
              zoom: config.endpoints.zoom,
              zoomURL: config.endpoints.zoomURL,
              report: config.endpoints.report,
              pheme: config.endpoints.pheme,
              audio: config.endpoints.audio,
              webSocketEndPoint: config.endpoints.webSocketEndPoint,
              teamsMeeting:config.endpoints.teamsMeeting,
              teamsDiscussion:config.endpoints.teamsDiscussion,
              meetingsFromAuth: config.endpoints.meetingsFromAuth,

              zoomAuthorizeEndpointURL: config.endpoints.zoomAuthorizeEndpointURL,
              contextPath: config.endpoints.contextPath,
              getAllProteanForm: config.endpoints.getAllProteanForm,
              getFormDetails: config.endpoints.getFormDetails,
              saveFormResponse: config.endpoints.saveFormResponse,
              getFormResposeDetails: config.endpoints.getFormResposeDetails,
              advanceSearchUrl: config.endpoints.advanceSearchUrl,
              collaboraURL: config.endpoints.collaboraURL
            }
          }
          this.AgoraConfig.next(conf_environment);

          //  setPhemeConfig(this.PhemeConfig.value)

          resolve(config);
        }, error: (error: any) => {
          reject(error);
        }
      });

    });
  }

  getConfig() {
    return this.AgoraConfig.getValue(); // Get the current config
  }
}